/** @module Camunda/StartProcessOnInstance */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/gallery/GalleryPlaceholder",
	"csi/html",
	"csi/locale",
	"csi/table/New",
	"csi/widget/Container",
	"csi/widget/LabeledWidget",
	"csi/xml",
	"Camunda"
], function(declare, _, GalleryPlaceholder, html, locale, New, Container, LabeledWidget, xml, Camunda) {

	/**
	 * Variable for toggleWaitDiv(), store domNode for darkened covering div
	 * @property {domNode} _waitDiv
	 */
	var _waitDiv = null;

	return declare(New, {
		bShowWait: true,

		/**
		 * @override
		 * Add dependency paths for main level
		 */
		getReturnNodeRequest: function(urlsNew) {
			const req = this.inherited(arguments);
			req.addDependencyPaths(this.widget.getMainQueryLevel().getDependencyPaths());
			return req;
		},

		/**
		 * @override
		 * Slide filmstrip view to reveal process templates that can be started
		 */
		preProcess: function() {
			const self = this;
			const buttonLabel = locale.resource("Start");
			const filmstrip = this.widget;
			const store = filmstrip.availableTemplateStore;

			function onStart() {
				// called in context of item
				self.m_writer.callMethod("Camunda", "StartWorkflow")
					.addParameter(xml.PROP_URL, xml.ATTR_REF, this.id)
					.addParameter("C8Instance", xml.ATTR_REF, filmstrip.urlRoot)
					.addParameter("Trigger", xml.ATTR_STRING, Camunda.TRIGGER_MANUAL);

				self.publish();
			}

			function onParams(item, params) {
				params["class"] = "csi-labeled-widget-to-right";
				params.separator = "";
				params.widgetProperties = {
					"class": html.CSS_BUTTON_SECONDARY,
					label: buttonLabel,
					onClick: onStart.bind(item)
				};
			}

			// Show darkened div cover for right part of filmstrip
			this.toggleWaitDiv(true);

			const css = "csi-container-select-list";
			const w = store.query().length ?
				new Container({
					"class": css,
					store: store,
					widgetClass: LabeledWidget,
					widgetProperties: ["disabled", "label"],
					onWidgetParams: onParams
				}) :
				new GalleryPlaceholder({
					"class": css,
					titleText: this.getString("Empty")
				});

			filmstrip.slideFilmstrip(this.getTitle(), w);

			// insert at top
			this.refNodeNext = filmstrip.bodyNode.firstChild;

			this._connectEvent(filmstrip, "onUnslideFilmstrip", function() {
				self.postProcess();
			});
		},

		/**
		 * @override
		 * Extract the process instance from the response
		 */
		onPublishResponse: function(response) {
			const process = _.findWhere(response.getNodes(), {$Type: "CamundaProcessInstance"});
			this.m_urlNode = process.$URL;
		},

		/**
		 * @override
		 * Wait for user to select another process to start if there was an error
		 */
		postProcess: function(bStatus, bRepeat) {
			if (bStatus === false) {
				this.inherited(arguments, [false, true]);
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Restore visibility of filmstrip
		 */
		postProcessSuccess: function() {
			this.widget.unslideFilmstrip();
			this.inherited(arguments);

			// update available templates to ensure templates are enabled/disabled correctly based on workflows that exist
			this.widget.updateAvailableTemplates();
		},

		/**
		 * @override
		 * Until server operation returns all new tasks, need to query for them now
		 */
		_hasReturnNodeRequest: function() {
			return true;
		},

		/**
		 * @override
		 * Expand row when inserted
		 */
		_newPostProcessRefNode: function(refNode) {
			this.inherited(arguments);
			this.widget.expandRow(refNode);
		},

		/**
		 * @override
		 * Remove darkened wait div 
		 */
		endProcess: function() {
			this.inherited(arguments);
			this.toggleWaitDiv(false);
		},

		/**
		 * Show darkened div cover for right part of filmstrip
		 * @param {boolean} bShow
		 */
		toggleWaitDiv: function(bShow) {
			const {widget: {filmstripMode, filmstripRightNode}} = this;

			if (filmstripMode) {
				if (bShow && !_waitDiv) {
					_waitDiv = html.create('div', {'class': 'csi-wait'}, filmstripRightNode);
				} else if (!bShow) {
					html.destroyElement(_waitDiv);
					_waitDiv = null;
				}
			}
		}
	});
});